import { Link } from 'react-router-dom';

function LoginHeader() {
    return (
        <header className="flex items-center justify-between border-b border-solid border-white/10 px-6 py-4 md:px-20 lg:px-40">
            <Link to="/">
                <div className="flex items-center gap-3">
                    <div className="size-8 bg-primary rounded flex items-center justify-center">
                        <span className="material-symbols-outlined text-white text-xl">speed</span>
                    </div>
                    <h1 className="text-xl font-bold tracking-tight text-white uppercase italic"><span className="text-primary">Live</span>Telemetry</h1>
                </div>
            </Link>

            <div className="flex flex-1 justify-end gap-8 items-center">
                <nav className="hidden md:flex items-center gap-9">
                    <p className="text-white/70 hover:text-white text-sm font-medium transition-colors"><Link to="/dashboard">Dashboard</Link></p>
                    <p className="text-white/70 hover:text-white text-sm font-medium transition-colors">Leaderboards</p>
                    <p className="text-white/70 hover:text-white text-sm font-medium transition-colors">Events</p>
                </nav>
                <Link to="/signup"><button className="flex min-w-[84px] cursor-pointer items-center justify-center rounded-lg h-10 px-5 bg-primary text-white text-sm font-bold transition-all hover:bg-primary/80">Get Started</button></Link>
            </div>
        </header>
    );
}

export default LoginHeader;